import './styles/index.css';

import { initSleepCounter } from './components/sleep-counter.js';
import { renderRoster } from './components/roster.js';
import { renderRules } from './components/rules.js';
import { renderNameLab } from './components/name-lab.js';
import { renderSchedule } from './components/schedule.js';
import { renderRecruitForm } from './components/recruit-form.js';
import { renderSponsorsDeck } from './components/sponsors-deck.js';
import { renderFaq } from './components/faq.js';
import { initPauseProtocol } from './components/pause-protocol.js';
import { initWagIntercept } from './components/wag-intercept.js';
import { initTilt } from './components/tilt.js';
import { initCountUp } from './components/count-up.js';
import { initH2Reveal } from './components/h2-reveal.js';
import { initScrollFx } from './components/scroll-fx.js';

function boot() {
  // render content first so other components can find the nodes
  renderRoster();
  renderRules();
  renderNameLab();
  renderSchedule();
  renderFaq();

  // initialize behaviors
  initSleepCounter();
  initCountUp();
  initH2Reveal();
  initPauseProtocol();
  initWagIntercept();
  initTilt();
  const fx = initScrollFx();

  // recruit form needs the scroll-fx watcher to animate its confirmation panel
  renderRecruitForm(node => fx && fx.watch && fx.watch(node));
  renderSponsorsDeck(node => fx && fx.watch && fx.watch(node));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}
